import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home')
    },
    {
      path: '/andra-losenord',
      name: 'ChangePassword',
      component: () => import(/* webpackChunkName: "changePassword" */ '@/views/ChangePassword')
    },
    {
      path: '/epost-bekraftad',
      name: 'EmailConfirmed',
      component: () => import(/* webpackChunkName: "emailConfirmed" */ '@/views/EmailConfirmed')
    },
    {
      path: '/villkor',
      name: 'Policy',
      component: () => import(/* webpackChunkName: "policy" */ '@/views/Policy')
    }
  ]
})
